import { render } from "./UpcomingMovies.vue?vue&type=template&id=78ee38c0&ts=true"
import script from "./UpcomingMovies.vue?vue&type=script&lang=ts"
export * from "./UpcomingMovies.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__